import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./gallery.css";

import GalleryImg1 from "../../assets/images/gallery/image.jpg";
import GalleryImg2 from "../../assets/images/gallery/image5.jpg";
import GalleryImg3 from "../../assets/images/gallery/image1.jpg";
import GalleryImg4 from "../../assets/images/gallery/image2.jpg";
import GalleryImg5 from "../../assets/images/gallery/image6.jpg";
import GalleryImg6 from "../../assets/images/gallery/image3.jpg";
import GalleryImg7 from "../../assets/images/gallery/image4.jpg";
import GalleryImg8 from "../../assets/images/gallery/image7.jpg";
import GalleryImg9 from "../../assets/images/gallery/image9.jpg";
import { Helmet } from "react-helmet-async";

const Gallery = () => {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const images = [
        GalleryImg1,
        GalleryImg2,
        GalleryImg3,
        GalleryImg4,
        GalleryImg5,
        GalleryImg6,
        GalleryImg7,
        GalleryImg8,
        GalleryImg9,
    ];

    const slides = images.map((src) => ({ src }));

    return (

        <div className="row">
            {images.map((img, i) => (
                <div className="col-6 col-md-4 mb-4" key={i}>
                    <div className="gallery-image-wrapper">
                        <img
                            src={img}
                            alt={`Gallery ${i + 1}`}
                            className="gallery-img"
                            onClick={() => {
                                setIndex(i);
                                setOpen(true);
                            }}
                        />
                    </div>
                </div>
            ))}

            <Lightbox open={open} close={() => setOpen(false)} index={index} slides={slides} />
        </div>
    );
};

export default Gallery;




// import React, { useState } from "react";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
// import "./gallery.css";

// import GalleryImg1 from "../../assets/images/gallery/image.jpg";
// import GalleryImg2 from "../../assets/images/gallery/image5.jpg";
// import GalleryImg3 from "../../assets/images/gallery/image1.jpg";
// import GalleryImg4 from "../../assets/images/gallery/image2.jpg";
// import GalleryImg5 from "../../assets/images/gallery/image6.jpg";
// import GalleryImg6 from "../../assets/images/gallery/image3.jpg";
// import GalleryImg7 from "../../assets/images/gallery/image4.jpg";
// import GalleryImg8 from "../../assets/images/gallery/image7.jpg";
// import GalleryImg9 from "../../assets/images/gallery/image9.jpg";

// import { Helmet } from "react-helmet-async";

// const Gallery = () => {
//     const [open, setOpen] = useState(false);
//     const [index, setIndex] = useState(0);

//     // ✅ Image + Vehicle Details
//     const vehicles = [
//         {
//             src: GalleryImg1,
//             name: "Toyota Innova Crysta",
//             seats: "7 Seater",
//             price: "₹15/km",
//             type: "AC SUV",
//         },
//         {
//             src: GalleryImg2,
//             name: "Swift Dzire",
//             seats: "4 Seater",
//             price: "₹12/km",
//             type: "AC Sedan",
//         },
//         {
//             src: GalleryImg3,
//             name: "Tempo Traveller",
//             seats: "12 Seater",
//             price: "₹20/km",
//             type: "Luxury Van",
//         },
//         {
//             src: GalleryImg4,
//             name: "Ertiga",
//             seats: "7 Seater",
//             price: "₹14/km",
//             type: "Family SUV",
//         },
//         {
//             src: GalleryImg5,
//             name: "Mahindra Xylo",
//             seats: "7 Seater",
//             price: "₹13/km",
//             type: "Comfort SUV",
//         },
//         {
//             src: GalleryImg6,
//             name: "Force Traveller",
//             seats: "17 Seater",
//             price: "₹25/km",
//             type: "Tour Van",
//         },
//         {
//             src: GalleryImg7,
//             name: "Tavera",
//             seats: "9 Seater",
//             price: "₹16/km",
//             type: "Non-AC SUV",
//         },
//         {
//             src: GalleryImg8,
//             name: "Luxury Bus",
//             seats: "35 Seater",
//             price: "₹40/km",
//             type: "AC Coach",
//         },
//         {
//             src: GalleryImg9,
//             name: "Ciaz",
//             seats: "4 Seater",
//             price: "₹11/km",
//             type: "Premium Sedan",
//         },
//     ];

//     const slides = vehicles.map((v) => ({ src: v.src }));

//     return (
//         <div className="gallery-container row">
//             {vehicles.map((vehicle, i) => (
//                 <div className="col-6 col-md-4 mb-4" key={i}>
//                     <div className="gallery-card" onClick={() => { setIndex(i); setOpen(true); }}>
//                         <img src={vehicle.src} alt={vehicle.name} className="gallery-img" />
//                         <div className="vehicle-info">
//                             <h5>{vehicle.name}</h5>
//                             <p>{vehicle.seats} • {vehicle.type}</p>
//                             <p className="price">{vehicle.price}</p>
//                         </div>
//                     </div>
//                 </div>
//             ))}

//             <Lightbox open={open} close={() => setOpen(false)} index={index} slides={slides} />
//         </div>
//     );
// };

// export default Gallery;
